import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { PartsfyHttpParams } from './_models/partsfyHttpParams';
import { UserService } from './user.service';

declare const addTooltip: any;
declare const isEmpty: any;

@Injectable()
export class SettingsService {
    public baseApiUrl: string = `${environment.api}/api`;
    public baseAuthUrl: string = `${environment.auth}/auth`;
    public baseAuthUserUrl: string = `${environment.auth}/users`;

    getTermosUsoVersion() {
        return this.executeGet({ url: `${this.baseApiUrl}/Account/GetTermosUsoVersion` });
    }

    constructor(private userService: UserService, private http: HttpClient) { }

    executeDelete(params: PartsfyHttpParams): Observable<any> {
        if (!params)
            params = { url: '' };

        let options: any = {};
        const getAuth = this.getHeaders();

        if (getAuth)
            options.headers = getAuth.headers;

        if (params.body)
            options.body = params.body;

        return this.http.delete<any>(`${this.getUrl(params)}`, options).pipe(map((result) => { setTimeout(() => addTooltip(), 200); return result }));
    }

    executeGet(params: PartsfyHttpParams): Observable<any> {
        const headers = this.getHeaders();
        return this.http.get<any>(`${this.getUrl(params)}`, headers).pipe(map((result) => { setTimeout(() => addTooltip(), 200); return result }));
    }

    executeGetWithToken(params: PartsfyHttpParams, token: string): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

        if (!params.body)
            params.body = {};

        return this.http.get<any>(`${this.getUrl(params)}`, { headers }).pipe(map((result) => { setTimeout(() => addTooltip(), 200); return result }));
    }

    executePatch(params: PartsfyHttpParams): Observable<any> {
        const headers = this.getHeaders();

        if (!params.body)
            params.body = {};

        return this.http.patch<any>(`${this.getUrl(params)}`, params.body, headers).pipe(map((result) => { setTimeout(() => addTooltip(), 200); return result }));
    }

    executePost(params: PartsfyHttpParams): Observable<any> {
        const headers = this.getHeaders(params.isJson);

        if (!params.body)
            params.body = {};

        return this.http.post<any>(`${this.getUrl(params)}`, params.body, headers).pipe(map((result) => { setTimeout(() => addTooltip(), 200); return result }));
    }

    executePostWithToken(params: PartsfyHttpParams, token: string): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

        if (!params.body)
            params.body = {};

        return this.http.post<any>(`${this.getUrl(params)}`, params.body, { headers }).pipe(map((result) => { setTimeout(() => addTooltip(), 200); return result }));
    }

    executePut(params: PartsfyHttpParams): Observable<any> {
        const headers = this.getHeaders();

        if (!params.body)
            params.body = {};

        return this.http.put<any>(`${this.getUrl(params)}`, params.body, headers).pipe(map((result) => { setTimeout(() => addTooltip(), 200); return result }));
    }

    get pathImagesPartsfy(): string { return `${environment.imageUrl.partsfy}`; }

    get pathImagesMercadoPartsfy(): string { return `${environment.imageUrl.mercadoPartsfy}`; }

    get pathImagesMercadoPartsfyNotFound(): string { return `${environment.imageUrl.mercadoPartsfy}/not-found.png`; }

    get pathLegalDocumentsPartsfy(): string { return environment.legalDocumentsUrl; }

    get directWhatsappIntegration(): boolean { return environment.directWhatsappIntegration; }

    get defaultPartsfyCashbackPercentage() { return 0.8; }

    get crispWhatsappUrl() { return 'https://plugins.crisp.chat/urn:crisp.im:whatsapp:0/wa/api/website/ea9e7131-c928-48eb-9a9d-2e78e79fa920/template/send'; }

    get crispPartsfyWhatsappNumber() { return '+55 11 4395-4552'; }

    getCaptchaData() { return { sitekey: '6LdNuj8UAAAAACATXK6oD6DvOUXnIdSC8VPBh7Sa', secretkey: '6LdNuj8UAAAAAIxW19wu6pDgFHgn6xIvnIIggU-G' }; }

    private getHeaders(isJson: boolean = true): any {
        if (this.userService.user() == null || this.userService.user() == undefined)
            return {};

        let headers = new HttpHeaders().set('Authorization', `Bearer ${this.userService.user().token}`);

        if (isJson)
            headers = headers.set('Content-Type', 'application/json');

        return { headers }
    }

    getLocale() { return 'pt-BR'; }

    getUrl(params: PartsfyHttpParams): string {
        if (!params || !params.url)
            return '';

        params.baseUrl = params.baseUrl ?? this.baseApiUrl;
        return `${params.baseUrl}${params.url}`
    }

    getUtalkUrl(is_from_support: boolean) {
        if (!is_from_support) // 11 96326-6464
            return 'https://v1.utalk.chat/send/bofpqa3/';
        else // 11 96573-0871
            return 'https://v1.utalk.chat/send/teav66g/';
    };

    getWhatsAppUrl() {
        return "https://api.whatsapp.com/send";
    }

    getWhatsAppWaMeSuporteUrl() {
        return "https://wa.me/5511965730871";
    }

    isMercadoPartsfy(vehicle: string) { return vehicle?.includes('Mercado Direto') }
    isMercadoPartsfyByPlate(licensePlate: string) { return licensePlate == 'MCX0000' || licensePlate == 'MCX-0000' }
    isQuotationInsumos(licensePlate: string) { return licensePlate == 'INS0000' || licensePlate == 'INS-0000' }

    isQuotationWithoutVehicle(licensePlate: string) { return this.isMercadoPartsfyByPlate(licensePlate) || this.isQuotationInsumos(licensePlate) }
}
